import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

function WordsTrEngCard({ TextValue, activeLevel }) {
  const [changeContent, setChangeContent] = useState("");
  const contentValue = useSelector((state) => state.contents.contentValues);

  const changeValue = (contentValue, activeLevel) => {
    let currentContent = "";
    if (contentValue.section === "reading" && activeLevel === "verbs") {
      currentContent = contentValue?.verbs?.[TextValue];
    }
    if (contentValue.section === "vocabulary" && activeLevel === "Beginner") {
      currentContent = contentValue?.contents?.[TextValue];
    }
    if (contentValue.section === "grammar" && activeLevel === "examples") {
      currentContent = contentValue?.examples?.[TextValue];
    }
    if (contentValue.section === "grammar" && activeLevel === "exercises") {
      currentContent = contentValue?.exercises?.[TextValue];
    }
    if (contentValue.section === "speaking" && activeLevel === "Beginner") {
      currentContent = contentValue?.constents?.[TextValue];
    }

    return currentContent;
  };

  useEffect(() => {
    const returnvalue = changeValue(contentValue, activeLevel);
    if (returnvalue) {
      setChangeContent(returnvalue);
    } else {
      console.log("İçerik bulunamadı:", {
        section: contentValue?.section,
        activeLevel,
        TextValue,
      });
      setChangeContent(""); // İçerik bulunamazsa state'i temizle
    }
  }, [activeLevel, contentValue, TextValue]); // Tüm bağımlılıkları ekle

  return (
    <div
      className="bg-white rounded-xl p-4 md:p-6 shadow-xl 
                hover:shadow-2xl transition-all w-full md:w-auto border-yellow-400 border-l-6"
    >
      <div className="space-y-3">
        <div>
          <span
            className="inline-block px-3 py-1 bg-purple-100
                 text-purple-700 font-semibold rounded-lg text-md md:text-lg mb-2"
          >
            English
          </span>
          <p className="text-md md:text-lg text-gray-700 leading-relaxed">
            {changeContent?.Eng || "Loading..."}
          </p>
        </div>
        <div>
          <span
            className="inline-block px-3 py-1 bg-green-100 text-green-700 
                font-semibold rounded-lg text-md md:text-lg mb-2"
          >
            Türkçe
          </span>
          <p className="text-md md:text-lg text-gray-700 leading-relaxed">
            {changeContent?.tr || "Yükleniyor..."}
          </p>
        </div>
      </div>
    </div>
  );
}

export default WordsTrEngCard;
